import { createApp } from "vue";
import SvgIcon from "@/icons";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"; // 导入插件
import App from "./App.vue";
import ElementPlus from "element-plus";
import router from "./router";
// 国际化中文
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import "@/assets/styles/border.css";
import "@/assets/styles/reset.css";
import "@/assets/styles/index.css"; // 私有政策 样式

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App);
SvgIcon(app);
app.use(pinia);

import "@/router/permission.js";
app.use(router).use(ElementPlus, { locale: zhCn });
app.mount("#app");
